import React from "react";
import { Col, Row } from "antd";
import styles from "../TicketUploadDrawer.module.scss";
import {
  DISPOSAL_JOB_KEY,
  getOrderDetailSummary,
  MiscellaneousConsts,
  orderDetailsHeaders,
} from "./constants";
import { TruckMaterialType } from "../../../../enums/truckMaterialType";
import {
  formatNumber,
  formatToFixedTwo,
} from "../../../../utils/numberFormatterUtil";

const OrderDetailsSummary = ({ orderDetails }) => {
  const { HOUR_KEY } = MiscellaneousConsts;

  const { order, deliveryInfo, salesPerson } = orderDetails ?? {};

  const {
    type,
    material: orderMaterial,
    materialName: orderMaterialName,
    truckType,
    minimumHours,
    truckingPrice,
    truckingPriceType,
    materialPrice,
    materialPriceType,
    materialCost: orderMaterialCost,
    materialCostType,
    landedPrice,
    landedPriceType,
    category,
    subCategory,
  } = order ?? {};

  const { pickup, pickupAddress, dropoffAddress, dropoff } = deliveryInfo ?? {};

  const isMaterialJob = type === TruckMaterialType.MATERIAL_TYPE;

  let material;
  if (isMaterialJob) {
    if (!!orderMaterial) {
      material = orderMaterial;
    } else {
      const materialStrings = orderMaterialName?.split("-");
      material =
        materialStrings?.length > 2
          ? materialStrings.slice(1).join(" - ")
          : materialStrings?.[1];
    }
  } else {
    material = orderMaterialName;
  }

  const pickUpName = pickup ?? "-";
  const pickUpAddress = pickupAddress ?? "-";
  const dropOffAddress = dropoffAddress ?? "-";
  const dropOffName = dropoff ?? "-";
  const truckTypes = truckType?.length ? truckType.join(", ") : "-";

  const minimumTruckingHours =
    truckingPriceType === HOUR_KEY
      ? minimumHours
        ? `${minimumHours} ${minimumHours > 1 ? "Hrs" : "Hr"}`
        : "-"
      : "-";

  const truckingRate = truckingPrice
    ? `$ ${formatNumber(formatToFixedTwo(truckingPrice))} per ${truckingPriceType}`
    : "-";

  const materialRate = materialPrice
    ? `$ ${formatNumber(formatToFixedTwo(materialPrice))} per ${materialPriceType}`
    : "-";

  const materialCost = orderMaterialCost
    ? `$ ${formatNumber(formatToFixedTwo(orderMaterialCost))} per ${materialCostType}`
    : "-";

  const landedRate = isMaterialJob
    ? materialPriceType === truckingPriceType
      ? `$ ${formatNumber(formatToFixedTwo(landedPrice))} per ${landedPriceType}`
      : "-"
    : truckingPrice
      ? `$ ${formatNumber(formatToFixedTwo(truckingPrice))} per ${truckingPriceType}`
      : "-";

  const salesperson = salesPerson ?? "-";
  const materialCategory = isMaterialJob ? (category ?? "-") : "-";
  const materialType = isMaterialJob
    ? (subCategory?.split("-")?.[1]?.trim() ?? "-")
    : "-";
  const materialName = material ?? "-";

  const orderDetailContent = getOrderDetailSummary({
    pickUpName,
    pickUpAddress,
    dropOffAddress,
    dropOffName,
    truckTypes,
    minimumTruckingHours,
    truckingRate,
    materialRate,
    materialCost,
    landedRate,
    salesperson,
    materialCategory,
    materialType,
    materialName,
    isMaterialJob,
  });

  return (
    <div className={styles.orderSummaryWrapper}>
      {orderDetailContent.map(([label, value], rowIndex) => (
        <div className={styles.tableBodyWrapper} key={rowIndex}>
          <Row>
            <Col span={6}>
              <div className={styles.tableTitleValues}>{label}</div>
            </Col>
            <Col span={18}>
              <div className={styles.tableContentValues}>{value}</div>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default OrderDetailsSummary;
